<div [formGroup]="listGroup" role="group" class="form-field" aria-describedby="listLabel">
  <span [class.bold]="bold" id="listLabel">{{name}}</span>
  <div class="scrolling-list" role="list">
    @for (controlName of listNames; track controlName; let i = $index) {
      <div
        [attr.aria-posinset]="i + 1"
        role="listitem"
        class="list-input"
        >
        <input
          [formControl]="getControl(controlName)"
          [attr.aria-label]="name + ' ' + (i + 1)"
          [placeholder]="placeholder"
          (input)="autoReplaceLastControl(controlName)"
          type="text"
          class="form-control valid-icon invalid-icon"
          >
        <button
          [disabled]="getControl(controlName).disabled"
          [class.invisible]="isLastControl(controlName)" (click)="deleteControl(controlName)"
          type="button" title="Delete" class="delete-button">
          <img [attr.alt]="'Delete ' + name + ' ' + (i + 1)" src="/assets/default/trash.svg">
        </button>
        @if (showError(controlName)) {
          <div class="input-error">
            <span>{{ errorPresentation(controlName) }}</span>
          </div>
        }
      </div>
    }
  </div>
</div>
